import moment from "moment";
import { getFilters } from "./filters";
import { sortNotes, getNotes } from "./manage-notes";

// Generate the DOM structure for a note
const generateNoteDOM = note => {
  const newNoteElement = document.createElement("a");
  const newTextElement = document.createElement("p");
  const newStatusElement = document.createElement("p");
  // Setup the note title text
  if (note.title.length > 0) {
    newTextElement.textContent = note.title;
  } else {
    newTextElement.textContent = "Unnamed Note";
  }
  newTextElement.classList.add("list-item__title");
  newNoteElement.appendChild(newTextElement);

  // Setup the link
  newNoteElement.setAttribute("href", `/note_data.html#${note.id}`);
  newNoteElement.classList.add("list-item");

  // Setup the status message
  newStatusElement.textContent = getLastEdited(note.updatedAt);
  newStatusElement.classList.add("list-item__subtitle");
  newNoteElement.appendChild(newStatusElement);

  return newNoteElement;
};

// Render Application notes
const renderNotes = () => {
  const notesEl = document.querySelector("#notes");
  const filters = getFilters();
  const notes = sortNotes(filters.sortBy);
  const filteredNotes = notes.filter(note =>
    note.title.toLowerCase().includes(filters.searchText.toLowerCase())
  );

  notesEl.innerHTML = "";
  if (filteredNotes.length > 0) {
    filteredNotes.forEach(note => {
      const newElement = generateNoteDOM(note);
      notesEl.appendChild(newElement);
    });
  } else {
    const emptyMessage = document.createElement("p");
    emptyMessage.textContent = "No notes to show!!";
    emptyMessage.classList.add("empty-message");
    notesEl.appendChild(emptyMessage);
  }
};

const intializeNotesEditPage = noteID => {
  const titleElement = document.querySelector("#note-title");
  const editInfo = document.querySelector("#edit-info");
  const bodyElement = document.querySelector("#note-body");
  const notes = getNotes();
  const note = notes.find(note => note.id === noteID);

  if (!note) {
    location.assign("/index.html");
  }

  titleElement.value = note.title;
  bodyElement.value = note.body;
  editInfo.textContent = getLastEdited(note.updatedAt);
};

// Generate the last Edited Information
const getLastEdited = timestamp => `Last Edited ${moment(timestamp).fromNow()}`;

export { generateNoteDOM, renderNotes, getLastEdited, intializeNotesEditPage };
